import { render, staticRenderFns } from "./DownlineList.vue?vue&type=template&id=5828ac48"
import script from "./DownlineList.vue?vue&type=script&lang=js"
export * from "./DownlineList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports